import api from '../../services/api';

const state = {
  timeseries: [],
  summary: null,
  loading: false,
};

const getters = {
  timeseries: s => s.timeseries,
  summary: s => s.summary,
  isLoading: s => s.loading,
};

const actions = {
  async fetchTimeseries({ commit }, { license_id, product_id, since, until, bucket = 'day' }) {
    if (!license_id) return { success: false, error: 'license_id required' };
    commit('SET_LOADING', true);
    try {
      const qs = new URLSearchParams({ license_id, bucket });
      if (product_id) qs.append('product_id', product_id);
      if (since) qs.append('since', since);
      if (until) qs.append('until', until);
      const res = await api.get(`/usage/timeseries?${qs.toString()}`);
      commit('SET_TIMESERIES', res.data);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.error || 'Failed to fetch' };
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async fetchSummary({ commit }, { license_id, since, until }) {
    if (!license_id) return { success: false, error: 'license_id required' };
    try {
      const qs = new URLSearchParams({ license_id });
      if (since) qs.append('since', since);
      if (until) qs.append('until', until);
      const res = await api.get(`/usage/summary?${qs.toString()}`);
      commit('SET_SUMMARY', res.data);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.error || 'Failed to fetch summary' };
    }
  },
};

const mutations = {
  SET_TIMESERIES(s, v) { s.timeseries = v; },
  SET_SUMMARY(s, v) { s.summary = v; },
  SET_LOADING(s, v) { s.loading = v; },
};

export default { namespaced: true, state, getters, actions, mutations };
